import { render, staticRenderFns } from "./fccAreaFormacao.vue?vue&type=template&id=2171b1cd"
import script from "./fccAreaFormacao.vue?vue&type=script&lang=js"
export * from "./fccAreaFormacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports